import React from 'react';
import { connect } from 'react-redux';
import { Button } from '@zola/zola-ui';
// import PropTypes from 'prop-types';
import { deleteOtherRegistry } from '../../../../actions/RegistryBulkImportActions';
import { hideModal } from '../../../../actions/ModalActions';

import './DeleteRegistryModal.less';

const DeleteOtherRegistryModal = ({ retailerName, registryId, handleDeleteOtherRegistry, closeModal }) => (
  <div className="other-registries__delete-modal">
    <h2 className="other-registries__delete-modal__header">Remove {retailerName} registry from Zola?</h2>
    <p>All gifts added from your {retailerName} registry will be removed from your Zola registry. We will no longer sync your {retailerName} registry. You can add your {retailerName} registry again anytime.</p>
    <div className="other-registries__delete-modal_ctas">
      <Button secondary size="lg" onClick={closeModal}>Cancel</Button>
      <Button error size="lg" onClick={() => handleDeleteOtherRegistry(retailerName, registryId)}>Remove Registry</Button>
    </div>
  </div>
);

const mapDispatchToProps = dispatch => ({
  handleDeleteOtherRegistry: (retailerName, registryId) => dispatch(deleteOtherRegistry(retailerName, registryId)),
  closeModal: () => dispatch(hideModal()),
});

export default connect(
  null,
  mapDispatchToProps
)(DeleteOtherRegistryModal);



// WEBPACK FOOTER //
// ./src/components/settings/registry/OtherRegistries/DeleteRegistryModal.jsx